// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function transformFields(fields: any[]): BackendFormField[] {
  if (!Array.isArray(fields)) return []

  const result: BackendFormField[] = []

  fields.forEach(field => {
    result.push({
      id: field.id,
      label: field.label,
      placeholder: field.placeHolder,
      type: field.displayType,
      level: field.level,
      allowedFiles: field.allowedFiles,
      ...(Array.isArray(field.options) && {
        options: field.options
      }),
      popoverInfo: field.popoverInfo,
      required:
        Array.isArray(field.validation) &&
        field.validation.findIndex(
          (validation: { type: string; params: string[] }) =>
            validation.type === 'required'
        ) !== -1
          ? true
          : false,
      ...(field.tag && { tag: field.tag }),
      ...(field.vertical && { vertical: field.vertical }),
      ...(field.hasHoverEffect && {
        hasHoverEffect: field.hasHoverEffect
      }),
      ...(field.creator_guideline && { guideline: field.creator_guideline }),
      ...(Array.isArray(field.templateOptions) && {
        options: field.templateOptions.map(
          (option: {
            title: string
            id: string
            image: string
            details: string
            multiSelect: boolean
            options: unknown[]
          }) => {
            return {
              ...option,
              icon: option.image
            }
          }
        )
      }),
      ...(Array.isArray(field.writerOptions) && {
        options: field.writerOptions.map(
          (option: { value: string; label: string; details: string }) => ({
            ...option,
            value: +option.value
          })
        )
      }),
      ...(Array.isArray(field.selectOptions) && {
        options: [...field.selectOptions, ...(field?.customFieldOptions || [])]
      }),
      helper: '',
      is_toggle: false,
      isVideoRecord: field.isVideoRecord,
      isAttachFile: field.isAttachFile,
      hideVideoUploadIcon: field.hideVideoUploadIcon,
      creator_label: field.creator_label
    })
  })

  return result
}
